import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import ScrollToTop from "../scrollToTopWrapper";
import i18n from '../../i18n.js'

export default function QuotationSuccess(props) {

    const{subtitle, text} = (props) = props;
    const [ord, setOrd] = useState(null) // Valor que se agrega a la variable ord de la etiqueta img al enviarse el formulario (para pixel de conversion)

    useEffect(() => {
      setOrdForPixelConvertionWhenFormSubmitted()
    
      return () => {
        setOrd(null)
      }
    }, [])
    

    const setOrdForPixelConvertionWhenFormSubmitted = () => {
        // Generar número aleatorio como hace el script
        const axel = Math.random() + "";
        const a = axel * 10000000000000;

        setOrd(a);
    }

    return(
        <ScrollToTop>
            {ord && (
                    <img
                        src={`https://ad.doubleclick.net/ddm/activity/src=13625920;type=invmedia;cat=venta0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=\${GDPR};gdpr_consent=\${GDPR_CONSENT_755};ord=${ord}?`}
                        width="1"
                        height="1"
                        alt=""
                        style={{ display: 'none' }}
                    />
                )}
            <div className={"text-center"}>

                <h4>
                    {subtitle}
                </h4>

                <p>
                    {text}
                </p>

            </div>

            <div className="row justify-content-center align-items-center px-md-5 mx-md-5">
                <div className="d-flex col-12 col-md-6 justify-content-center align-items-center mx-0">
                    <Link to="/preguntas-frecuentes"
                          type="button"
                          className="fix-button-link btn w-100 btn-primary rounded-pill g-action-button"
                    >
                        {i18n.t('quotation.update.button1')}
                    </Link>
                </div>
                <div className="d-flex col-12 col-md-6 justify-content-center mx-0">
                    <Link to="/"
                          type="button"
                          className="fix-button-link btn w-100 btn-outline-primary rounded-pill px-4 g-action-button-outline"
                    >
                        {i18n.t('quotation.update.button2')}
                    </Link>
                </div>
            </div>

        </ScrollToTop>
    )

}